import { NextSeo } from 'next-seo';
import { useRouter } from 'next/router';
import getConfig from 'next/config';
import { ServerSideSearchClient } from '@monofront/business/services/algolia/serverSideClient';
import { generateCollectionIndexName } from '@monofront/business/utils';
import { useTranslations } from 'next-intl';
import { GetServerSideProps } from 'next';
import { LFPage, injectLayoutData } from '@utils/layout';
import { injectGetServerSidePropsHeaders } from '@utils/query';
import { ICollectionsListProps, CollectionsList } from '@screens/Collection';

const {
  publicRuntimeConfig: { appBaseUrl },
  publicRuntimeConfig: { algoliaConfig },
  serverRuntimeConfig: { algoliaConfig: browseConfig },
} = getConfig();

interface ICollectionListServerSideProps {
  props: ICollectionsListProps;
}

const CollectionsListPage: LFPage<ICollectionsListProps> = ({
  collections,
}) => {
  const router = useRouter();

  const tCatalog = useTranslations('Catalog');

  const urlPath = router.asPath.split('?')[0];

  return (
    <>
      <NextSeo
        title={tCatalog('collectionsList')}
        canonical={`${appBaseUrl}${urlPath}`}
        openGraph={{
          url: `${appBaseUrl}${urlPath}`,
          title: tCatalog('collectionsList'),
        }}
      />
      <CollectionsList collections={collections} />
    </>
  );
};

export const getServerSideProps =
  injectGetServerSidePropsHeaders<ICollectionsListProps>(
    injectLayoutData<ICollectionsListProps, GetServerSideProps>(
      async ({ locale }): Promise<ICollectionListServerSideProps> => {
        const collectionService = new ServerSideSearchClient(
          algoliaConfig.app.id,
          browseConfig.browse.key,
          generateCollectionIndexName(algoliaConfig.environment, locale),
        );

        const collections = await collectionService.getAllPublicCollections();

        return {
          props: {
            collections: collections.map(({ handle, title }) => ({
              handle,
              title,
            })),
          },
        };
      },
    ),
  );

export default CollectionsListPage;
